export function MenuBoard({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.893 7.29587L16.1181 14.805C16.1331 15.0075 16.0356 15.1425 15.9831 15.2025C15.9231 15.27 15.7956 15.375 15.5856 15.375L14.734 15.3631L13.875 15.375L15.8219 7.58131L15.893 7.29587ZM16.5006 4.5L16.4931 4.515C16.5081 4.695 16.4931 4.8825 16.4481 5.07L13.875 15.375C13.695 16.1325 10.0656 16.5 9.28564 16.5H15.5856C16.5531 16.5 17.3181 15.6825 17.2431 14.715L16.5006 4.5Z"
          fill="currentColor"
        />
        <path
          d="M8.58768 1.68029C8.66268 1.38029 8.47518 1.07279 8.17518 0.997791C7.87518 0.930291 7.56768 1.11029 7.49268 1.41029L7.11768 2.96279H8.27268L8.58768 1.68029Z"
          fill="currentColor"
        />
        <path
          d="M13.5381 1.65717C13.6056 1.34967 13.4106 1.05717 13.1031 0.989674C12.8031 0.922174 12.5031 1.11717 12.4356 1.42467L12.0981 2.97717H13.2531L13.5381 1.65717Z"
          fill="currentColor"
        />
        <path
          d="M16.3648 3.99782C16.1173 3.39782 15.5323 2.97032 14.8123 2.97032H13.2523L12.8323 4.91282C12.7723 5.17532 12.5398 5.35532 12.2848 5.35532C12.2473 5.35532 12.2023 5.35532 12.1648 5.34032C11.8648 5.27282 11.6698 4.97282 11.7298 4.67282L12.0973 2.96282L8.27268 2.96279L7.79982 4.91282C7.73982 5.16782 7.50732 5.34032 7.25232 5.34032C7.20732 5.34032 7.16232 5.33282 7.11732 5.32532C6.81732 5.25032 6.62982 4.95032 6.70482 4.64282L7.10982 2.95532H5.58732C4.85232 2.95532 4.19982 3.43532 3.98232 4.14032L0.824816 14.3028C0.494816 15.3903 1.29732 16.5003 2.42982 16.5003H12.2848C13.0648 16.5003 13.7398 15.9753 13.9198 15.2178L16.4473 5.07032C16.4923 4.88282 16.5073 4.69532 16.4923 4.51532C16.4773 4.33532 16.4398 4.15532 16.3648 3.99782ZM11.0248 12.5628H5.02482C4.71732 12.5628 4.46232 12.3078 4.46232 12.0003C4.46232 11.6928 4.71732 11.4378 5.02482 11.4378H11.0248C11.3323 11.4378 11.5873 11.6928 11.5873 12.0003C11.5873 12.3078 11.3323 12.5628 11.0248 12.5628ZM11.7748 9.56282H5.77482C5.46732 9.56282 5.21232 9.30782 5.21232 9.00032C5.21232 8.69282 5.46732 8.43782 5.77482 8.43782H11.7748C12.0823 8.43782 12.3373 8.69282 12.3373 9.00032C12.3373 9.30782 12.0823 9.56282 11.7748 9.56282Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.35"
        />
      </svg>
    </span>
  );
}
